export const USER_LANG_LOCAL_STORAGE_KEY = 'userLang';
